import { useCallback, useState } from "react";
import { message } from "antd";
import { useTranslation } from "react-i18next";
import {
  CashTransaction,
  CashboxSummary,
  TodayCashboxSearchParams,
} from "../../../types/cashTransactionTypes";
import { getTodayCashbox } from "../../../services/cashTransactionService";

export const useTodayCashbox = () => {
  const { t } = useTranslation();

  const [transactions, setTransactions] = useState<CashTransaction[]>([]);
  const [summary, setSummary] = useState<CashboxSummary>({
    cashBoxId: null,
    initialBalance: 0,
    currentBalance: 0,
    difference: 0,
  });
  const [hasTodayCashBox, setHasTodayCashBox] = useState<boolean>(false);

  const [pagination, setPagination] = useState({
    page: 1,
    limit: 50,
    total: 0,
  });

  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const fetchTodayCashbox = useCallback(
    async (params: TodayCashboxSearchParams = {}) => {
      setLoading(true);
      try {
        const result = await getTodayCashbox(params);
        setTransactions(result.data.data || []);
        setSummary(result.data.cashboxSummary || summary);
        setHasTodayCashBox(result.data.hasTodayCashBox);
        setPagination(result.pagination || pagination);
        setError(null);
      } catch (err) {
        console.error(err);
        setError(t("cashbox.errors.failed_to_fetch_transactions"));
        // message.error(t("cashbox.errors.failed_to_fetch_transactions"));
      } finally {
        setLoading(false);
      }
    },
    [t]
  );

  return {
    transactions,
    summary,
    hasTodayCashBox,
    pagination,
    loading,
    error,
    fetchTodayCashbox,
  };
};

export default useTodayCashbox;
